import Service from '@/service/index.js';
import { mapGetters } from 'vuex';
import { personalCenterMenu } from '@/utils/default-data.js';
import SigninDialog from '@/views/signin/signin-dialog/signin-dialog.vue';
import { isProvincialSites } from '@/utils/common.js';
export default {
  components: {
    SigninDialog
  },
  props: {
    defaultActiveIndex: {
      type: Number,
      default: Date.now() + ''
    }
  },
  data() {
    return {
      perCenterMenu: personalCenterMenu,
      menuList: [
        { name: '首页', url: '/index' },
        { name: '新闻中心', url: ''},
        { name: '交易项目', url: '/transaction-pro/list' },
        { name: '采购项目', url: '/collective-purchasing/list' },
        { name: '竞价大厅', url: '/bid-project/list' },
        // { name: '登记托管', url: '', children: [{ name: '托管业务', url: '' }, { name: '信息披露', url: '/registration-hosting/hostList' }, { name: '登记托管信息', url: '/registration-hosting/trading-rules-list/5' }] },
        // { name: '通知公示', url: '', children: [{ name: '成交公示', url: '/notice-modular/list' }, { name: '交易鉴证', url: '/notice-modular/noticeList' }, { name: '变更项目公示', url: '/notice-modular/trading-rules-list/6' }, { name: '系统更新公示', url: '/notice-modular/system-update-list/7' }] },
        { name: '通知公示', url: '', children: [{ name: '成交公示', url: '/notice-modular/list' }, { name: '交易鉴证', url: '/notice-modular/noticeList' }] },
        { name: '政策规章', url: ''}
        // { name: '关于我们', url: '', children: [{ name: '合作伙伴', url: '/about-us/market-member-list' }]  }
      ],
      activeIndex: this.defaultActiveIndex + '',
      dialogVisible: false,
      showMenu: false
    };
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  watch: {
    defaultActiveIndex (newValue) {
      this.activeIndex = newValue + '';
    }
  },
  created() {
    const obj = {
      NEWS_SECOND_TAG: 'newsTag',
      REGULATIONS_SECOND_TAG: 'regulationsTag'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          // 新闻中心
          if (key === 'NEWS_SECOND_TAG') {
            // res.data = res.data.splice(0, 2);

            // 如果是子网站 显示地方要闻
            let childWebSite  = !isProvincialSites();
            if(childWebSite) {
              res.data.splice(2, 1);
            } else {
              res.data = res.data.splice(0, 1);
            }
            this.menuList[1].children = res.data.map((item => {
              return {name: item.value, url: '/news/news-list/' + item.code};
            }));
          }
          // 政策规章
          if (key === 'REGULATIONS_SECOND_TAG') {
            this.menuList[6].children = res.data.map((item => {
              return {name: item.value, url: '/trading-rules/trading-rules-list/' + item.code};
            }));
          }
          this.menuList = JSON.parse(JSON.stringify(this.menuList));
          this.changeActiveIndex();
        }
      });
    });
    // 非个人用户不显示我的托管业务
    if(this.userInfo.type !== 1) {
      this.perCenterMenu.forEach(item => {
        if(item.name === '我的托管业务') {
          this.perCenterMenu.splice(6, 1);
        }else {
          // return
        }
      });
    }
  },
  methods: {
    chooseMenu(item, index) {
      if (!item.url) {
        return;
      }
      if (index === 1) {
        this.$store.commit('SET_NAV_LIST', [{path: '/index', title: '首页'},
          {path: '/news/news-list/1', title: '新闻中心'}, {path: item.url, title: item.name}]);
      } else if (index === 6) {
        this.$store.commit('SET_NAV_LIST', [{path: '/index', title: '首页'},
          {path: '/trading-rules/trading-rules-list/1', title: '政策规章'}, {path: item.url, title: item.name}]);
      }
      this.$router.push(item.url);
    },
    changeActiveIndex () {
      this.menuList.forEach((element, index) => {
        // 有二级菜单遍历 刷新时不重置
        if( element.children ) {
          element.children.forEach((item, indexs) => {
            if( item.url === this.$route.path ){
              this.activeIndex = `${index}-${indexs + 1}`;
            }
          });
        } else {
          if( element.url === this.$route.path ){
            this.activeIndex = index.toString();
          };
        }
      });
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      console.log(key, keyPath);
    },
    // 去往个人中心/退出登录
    toPath(item) {
      if (item.path) {
        this.$router.push(item.path);
      } else if (!item.path && item.name === '退出登录') {
        this.$confirm('确定要退出登录？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.commit('SET_USER_INFO', {});
          window.localStorage.clear();
          this.$router.push('/index');
        }).catch();
      }
    },

    isShowSigninAction() {
      if (!this.userInfo || !this.userInfo.username) {
        this.dialogVisible = true;
      } else {
        this.showMenu = true;
      }
    },

    // 登录
    login() {
      if ((this.userInfo && this.userInfo.username) || this.$route.path === '/signin') {
        return;
      }
      // 判断是否是注册页面点击登录：如果是注册页面需要跳转到登录页面，不使用弹窗
      const isRegisterPath = this.$route.path && this.$route.path.indexOf('/register') !== -1;
      if (isRegisterPath) {
        this.$router.push('/signin');
      } else {
        this.dialogVisible = true;
      }
      if (this.$refs['signinDialog']) {
        this.$refs['signinDialog'].onReset();
        this.$refs['signinDialog'].resetFormRules();
        this.$refs['signinDialog'].active = false;
      }
    }
  }
};
